import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectUser } from "../../store/authSlice";

function Nav() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const userData = useSelector(selectUser);

  // 基礎選單項目
  const baseNavItems = [
    { to: "/realtime", label: "耗能即時資訊", icon: "/assets/icons/bolt.svg" },
    {
      to: "/statistics",
      label: "耗能統計分析",
      icon: "/assets/icons/chart-pie-alt.svg",
    },
    { to: "/water", label: "用水資訊分析", icon: "/assets/icons/water.svg" },
    { to: "/users", label: "客戶資訊", icon: "/assets/icons/user.svg" },
    { to: "/setting", label: "設定頁面", icon: "/assets/icons/setting.svg" },
  ];

  // 只有 account_id === 2 才顯示首頁
  const navItems = userData?.account_id !== 1
    ? [{ to: "/home", label: "首頁", icon: "/assets/icons/bolt.svg" }, ...baseNavItems]
    : baseNavItems;

  const handleSignOut = async () => {
    try {
      await dispatch(logout()).unwrap();
      // Redux 會自動把 isAuth = false
    } catch (err) {
      console.error("登出失敗：", err);
    }
  };

  return (
    <>
      {/* 漢堡按鈕 & 標題 (手機) */}
      <header className="lg:hidden relative flex items-center justify-center p-4 bg-[#261E35]">
        <button
          onClick={() => setMobileOpen(true)}
          className="absolute left-4 text-3xl focus:outline-none z-10"
        >
          <HiMenu />
        </button>
        <h2 className="text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-300 to-blue-500">
          EMS System
        </h2>
      </header>

      {/* 側邊欄 */}
      <nav
        className={`
          fixed flex flex-col top-0 left-0 h-full w-full md:w-[220px] lg:w-[258px] md:min-w-[200px] lg:min-w-[258px] 
          bg-[#261E35] md:border-r md:border-white/15 p-4 transform transition-transform
          lg:relative lg:translate-x-0 z-[10]
          ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        {/* 手機關閉按鈕 */}
        <div className="lg:hidden flex justify-end mb-4">
          <button onClick={() => setMobileOpen(false)} className="text-2xl">
            <HiX />
          </button>
        </div>

        {/* Logo */}
        <ul className="w-full flex flex-col gap-4">
          <li>
            <div className="flex flex-col items-center w-full justify-center h-[120px] rounded-[16px] gap-4 ">
              <img
                src={"/assets/logo/logo512.png"}
                alt={"Home"}
                className="w-[80px] h-[80px]"
              />
              <span className="text-title-s-lg md:text-title-s-sm font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#66E6F9] to-[#3C8893]">
                EMS System
              </span>
            </div>
          </li>

          {/* 選單項目 */}
          {navItems.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) => `
                  border border-white flex items-center relative overflow-hidden
                  p-4 gap-5 transition-all duration-300 ease-in-out rounded-[16px]
                  ${isActive ? "bg-[#308681]" : "bg-[#69666680]"}
                  hover:bg-[#30868180]
                `}
              >
                <img
                  src={item.icon}
                  alt={item.label}
                  className="w-5 h-5 flex-none"
                />
                <span
                  className={`
                    text-button-m-lg lg:text-button-l-lg lg:text-[24px]
                    transition-transform duration-300 ease-in-out
                    ${
                      item.to === location.pathname
                        ? "translate-x-0"
                        : "translate-x-2"
                    }
                  `}
                >
                  {item.label}
                </span>
              </NavLink>
            </li>
          ))}
        </ul>

        {/* 底部登出 */}
        <div className="mt-auto pt-4 relative">
          {/* <div className="absolute bottom-[120px] w-full opacity-30 flex flex-col items-center justify-center">
            <img
              src="/assets/images/looper-line.png"
              alt="loop-bg"
              className="w-[288px] md:min-w-[300px] lg:min-w-[320px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-0"
            />
            <p className="text-[76px] lg:text-[88px] font-[300] text-transparent bg-clip-text bg-gradient-to-r from-[#66E6F9] to-[#3C8893] z-10">
              EMS
            </p>
          </div> */}
          <button
            onClick={handleSignOut}
            className="w-full flex items-center p-4 gap-5 rounded-[16px] 
            bg-[#69666680] border border-white hover:bg-red-600 group transition-colors"
          >
            <img
              src={"/assets/icons/sign-out.svg"}
              alt={"sign-out"}
              className="w-[20px] h-[20px]"
            />
            <span className="text-button-m-lg lg:text-button-l-lg lg:text-[24px] translate-x-2 group-hover:translate-x-0 transition-transform duration-300 ease-in-out">
              離開系統
            </span>
          </button>
        </div>
      </nav>

      {/* 手機遮罩 */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}
    </>
  );
}

export default Nav;
